import { render, staticRenderFns } from "./grossing-touch-subportion-card.vue?vue&type=template&id=6e8d8eb8&scoped=true&"
import script from "./grossing-touch-subportion-card.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-subportion-card.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-subportion-card.scss?vue&type=style&index=0&id=6e8d8eb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8d8eb8",
  null
  
)

export default component.exports